var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view',{directives:[{name:"show",rawName:"v-show",value:(this.$route.matched.length==3),expression:"this.$route.matched.length==3"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }